/**
 * Generates an RB key for filter pills.
 *
 * @param {string} filterLabel - The label of the filter.
 * @param {string} tagList - The tag list name.
 */
export const getFilterPillRBKey = ({ filterLabel, tagList }) => {
  if (!filterLabel || !tagList) {
    return '';
  }

  const filter = tagList.replace(/^tag_/, '').replace(/_list$/, '');
  const filterOption = filterLabel.replace(/ |-/g, '_').toLowerCase();

  return `${filter}_${filterOption}`;
};

/**
 * Generates an autotag value for filter pills and images.
 *
 * @param {object} props - The props object.
 * @param {boolean} props.isPill - Whether the tag is a pill.
 * @param {boolean} props.isImage - Whether the tag is an image.
 * @param {string} props.tagName - The tag name (from asset.customVars.tag_name)
 * @param {string} props.activeCategoryLabel - The active category label from the page
 * @returns {string} The autotag value.
 */
export const getAutotagValue = ({
  isPill,
  isImage,
  tagName,
  activeCategoryLabel,
}) => {
  if (!activeCategoryLabel) {
    return '';
  }

  let tagType;
  if (isPill) {
    tagType = 'pill';
  } else if (isImage) {
    tagType = 'image';
  }

  const normalizedTagName = tagName.replace(/ |-/g, '_').toLowerCase();

  return `filter-bar-${tagType}${
    activeCategoryLabel ? `-${activeCategoryLabel}` : ''
  }-${normalizedTagName}`;
};
